/**
 * Ключі полів модуля «Перенесення даних» → поняття довідника (значок «?» біля підпису).
 * Координатор підключає мапу в features/knowledge/fieldTerms.ts; до того значків немає.
 * Терміни — як у словнику сервера. «Статистика» у словнику — «показник підрозділу з періодичністю»,
 * тому вона прив’язана до назви таблиці «Статистика ОЕ», а не до протоколу звірки.
 */
export const MIGRATION_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Джерела перенесення.
  'migration.source.up': 'УП',
  'migration.source.sheet_services': 'Структура ЮВ',
  'migration.source.sheet_oe': 'ОЕ',
  // Параметри імпорту «Структури ЮВ».
  'migration.params.portfolio': 'ЯДРО',
  'migration.params.defaultCategory': 'Категорія послуги',
  // Архів журналу «Статистика ОЕ».
  'migration.oeJournal': 'ОЕ',
  'migration.oeJournal.statistics': 'Статистика',
};

/** Ключ поняття для джерела (лише для тих, що є в мапі). */
export function sourceTermKey(source: string): string | undefined {
  const key = `migration.source.${source}`;
  return Object.prototype.hasOwnProperty.call(MIGRATION_FIELD_TERMS, key) ? key : undefined;
}
